import { FC, useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { View } from "../../components/layout/View";
import PaperCard from "../../components/widgets/PaperCard";
import { PageType } from "../../config/page.types";
import { useBreadcrumbs } from "../../context/BreadcrumbsProvider";
import { capitalizeWords } from "../../hooks/common";
import CurrentUserPassword from "./components/CurrentUserPassword";
import CurrentUserRegistry from "./components/CurrentUserRegistry";

/**
 * CurrentUser renders the UI for reviewing and updating details of the current user.
 *
 * @constructor
 */
const CurrentUser: FC = () => {
	const { t } = useTranslation("feature.account");
	const { visitPage } = useBreadcrumbs();
	const [tab, setTab] = useState<"registry" | "password">("registry");
	const [accountName, setAccountName] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (accountName) {
			const capitalizeName = capitalizeWords(accountName);
			visitPage(PageType.Account, true, capitalizeName);
		}
	}, [accountName, visitPage]);

	return (
		<View pageType={PageType.Account}>
			<Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
				<Tab label={t("registry")} value={"registry"} />
				<Tab label={t("change password")} value={"password"} />
			</Tabs>

			<Box hidden={tab !== "registry"}>
				<PaperCard
					sxContent={{ pt: 3, pb: 2 }}
					content={
						<CurrentUserRegistry updateAccountDisplayName={(displayName) => setAccountName(displayName)} />
					}
				></PaperCard>
			</Box>
			<Box hidden={tab !== "password"}>
				<PaperCard sxContent={{ pt: 3, pb: 2 }} content={<CurrentUserPassword />}></PaperCard>
			</Box>
		</View>
	);
};

export default CurrentUser;
